import { StyledButton } from '../../../../components/StyledComponents';
import Icon from '../../../../components/Icon';
import styles from '../calls_queue.module.scss'
import { useTypedSelector } from '../../../../redux/hooks';
import { selectAvailableAgentsInQueue, selectQueuePanelByUuid, selectSortedQueuePanels } from '../../../../redux/slices/queueSlice';
import AgentTable from './AgentTable';
import { usePanelContext } from '../panelContext';

const SinglePanelAgents = ({
    panelUuid,
    onBack,
    dataLoading
}: {
    panelUuid: string;
    onBack?: () => void;
    dataLoading: boolean;
}) => {
    const panel = useTypedSelector(state => selectQueuePanelByUuid(state, panelUuid))
    const availableAgents = useTypedSelector(state => selectAvailableAgentsInQueue(state, panel?.queue_uuid || ' '));

    if (!panel) {
        return null;
    }

    return (
        <div key={panel.uuid} className={styles.queue_panel_agents_main_container}>
            <div className={styles.heading}>
                {onBack ? (
                    <StyledButton buttonStyle="text" iconOnly className={styles.back_button} onClick={onBack}>
                        <Icon name="arrowLeft" />
                    </StyledButton>
                ) : null}
                <div className={styles.header}>
                    <h2>{panel.name}</h2>
                    <p>{panel.queue_users.length} Agent{panel.queue_users.length !== 1 ? 's' : ''}, {availableAgents} Available</p>
                </div>
            </div>
            <div className={styles.table_container}>
                <AgentTable queueUuid={panel.queue_uuid} dataLoading={dataLoading} />
            </div>
        </div>
    );
}

const ListedPanels = ({
    onBack,
    dataLoading,
}: {
    onBack: () => void;
    dataLoading: boolean;
}) => {

    const {
        selectedPanelList,
    } = usePanelContext();

    const panels = useTypedSelector(selectSortedQueuePanels);

    if (selectedPanelList.length > 0) {
        return (<div>
            {selectedPanelList.map((panelUuid, idx) => (
                <SinglePanelAgents
                    key={panelUuid}
                    panelUuid={panelUuid}
                    onBack={idx === 0 ? onBack : undefined}
                    dataLoading={dataLoading}
                />
            ))}
        </div>)
    }

    return (<div>
        {panels.map((panel, idx) => (
            <SinglePanelAgents
                key={panel.uuid}
                panelUuid={panel.uuid}
                onBack={idx === 0 ? onBack : undefined}
                dataLoading={dataLoading}
            />
        ))}
    </div>)
}


const AllAgents = ({
    onBack,
    dataLoading
}: {
    onBack: () => void;
    dataLoading: boolean
}) => {
    const {
        selectedPanelList,
    } = usePanelContext();

    const allAvailableAgents = useTypedSelector(state => selectAvailableAgentsInQueue(state, 'all'));

    return (
        <div className={styles.queue_panel_agents_main_container}>
            <div className={styles.heading}>
                <StyledButton
                    buttonStyle="text"
                    iconOnly
                    className={styles.back_button}
                    onClick={onBack}
                >
                    <Icon name="arrowLeft" />
                </StyledButton>
                <div className={styles.header}>
                    <h2>All Agents</h2>
                    <p>{allAvailableAgents} Agent{allAvailableAgents > 1 ? 's' : null} Available</p>
                </div>
            </div>
            <div className={styles.table_container}>
                <AgentTable queueUuid={selectedPanelList} dataLoading={dataLoading} />
            </div>
        </div>
    );
}

export default function Agents({
    onBack,
    dataLoading,
}: {
    onBack: () => void;
    dataLoading: boolean;
}) {

    const {
        selectedPanelUuid,
        agentFilterOption
    } = usePanelContext();

    if (selectedPanelUuid) {
        return (<SinglePanelAgents
            panelUuid={selectedPanelUuid}
            onBack={onBack}
            dataLoading={dataLoading}
        />);
    }

    if (agentFilterOption === 'By Queue') {
        return (
            <ListedPanels
                onBack={onBack}
                dataLoading={dataLoading}
            />
        );
    }

    return (
        <AllAgents
            onBack={onBack}
            dataLoading={dataLoading}
        />
    )
}
